import './style.css';

import React from 'react';

import LoadingPanelLoader from './controls/loader';

interface IProps extends React.PropsWithChildren {
  className?: string;
  containerStyle?: React.CSSProperties;
  flex?: boolean;
  loading?: boolean;
  overlayStyle?: React.CSSProperties;
  size?: number;
  style?: React.CSSProperties;
  type?: 'linear';
}

const LoadingPanel: React.FC<IProps> = React.memo((props) => {
  const { children, className, containerStyle, flex, loading, overlayStyle, size, type } = props;

  const style = React.useMemo(() => {
    const visibility = loading ? 'hidden' : 'visible';
    if (flex) {
      return Object.assign(
        {
          flex: '1 1',
          display: 'flex',
          maxWidth: '100%',
          flexDirection: 'column',
          visibility
        },
        containerStyle
      );
    } else {
      return { width: '100%' };
    }
  }, [containerStyle, flex, loading]);

  return (
    <div className={className + ' loading-panel'} style={props.style} data-testid="loading-panel">
      {loading && (
        <LoadingPanelLoader
          overlayStyle={overlayStyle}
          size={size}
          style={props.style}
          type={type}
        />
      )}
      <div style={style}>{children}</div>
    </div>
  );
});

LoadingPanel.displayName = 'LoadingPanel';

export default LoadingPanel;
